import brasao from '../../assets/img/brasao.png';
import { Modal } from 'react-bootstrap';
import '../../assets/css/styles.css';

function LegislacaoModal({ show, onHide }) {
  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      className="legislacao-modal"
      backdrop="static"
    >
      <Modal.Header className="flex-column border-0 pb-0">
        <div className="text-center mb-3">
          <img 
            src={brasao}
            alt="Brasão SSE-DF" 
            className="mb-2" 
            height="80"
          />
          <Modal.Title as="h3">Legislação</Modal.Title>
        </div>
        <button 
          type="button" 
          className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
          onClick={onHide}
          aria-label="Close"
        />
      </Modal.Header>
      <Modal.Body className="pt-0">
        <ul className="legislacao-list">
          <li>
            <i className="bi bi-book me-2"></i>
            <strong>Estatuto da Criança e do Adolescente</strong> – Lei nº 8.069/1990
          </li>
          <li>
            <i className="bi bi-journal-text me-2"></i>
            <strong>Lei nº 12.594/2012</strong> – SINASE
          </li>
          <li>
            <i className="bi bi-file-earmark-text me-2"></i>
            <strong>Acordo de Cooperação Técnica</strong> publicado no DODF, nº 81 no dia 03/05/2021
          </li>
          <li>
            <i className="bi bi-folder me-2"></i>
            <strong>Plano de trabalho NAI</strong> – PROCESSO 00400-00047653/2019-95
          </li>
        </ul>
      </Modal.Body>
    </Modal>
  );
}

export default LegislacaoModal;